import {
	AnimatedFeedbackBlock,
	FeedbackAnimation,
} from "@bokio/components/AnimatedFeedbackBlock/AnimatedFeedbackBlock";
import { Button, ButtonGroup } from "@bokio/designsystem/components/Button";
import { Modal, ModalContent } from "@bokio/designsystem/components/Modal";
import Markdown from "@bokio/elements/Markdown/Markdown";
import { GeneralLangFactory } from "@bokio/lang";

import type { FC } from "react";

interface TrialExtendedModalProps {
	resolve: () => void;
	dismiss: () => void;
}

export const TrialExtendedModal: FC<TrialExtendedModalProps> = ({ resolve, dismiss }) => {
	const generalLang = GeneralLangFactory();
	return (
		<Modal
			visible={true}
			title={generalLang.TrialExtendedModal_Heading}
			disableBackgroundClick={true}
			onClose={dismiss}
		>
			<ModalContent>
				<AnimatedFeedbackBlock animation={FeedbackAnimation.Celebration} title="" />
				<Markdown markdownContent={generalLang.TrialExtendedModal_Message} deprecatedOptoutFromTypographicElements />
				<ButtonGroup margin={["top"]} align="end">
					<Button appearance="primary" onClick={resolve} align="flex-end">
						{generalLang.TrialExtendedModal_CTA}
					</Button>
				</ButtonGroup>
			</ModalContent>
		</Modal>
	);
};
